import { ISAUTHENTICATED } from "../constants/reduxConstants";

export const authAction = (payload) => {
  return {
    type: ISAUTHENTICATED,
    payload: payload,
  };
};
